<template>
  <v-container>
    <h1 v-if="hasEvent">{{ vendor.name }} på Amanda torsdag 10. august 2020</h1>

    <h1 v-if="!hasEvent">
      {{ vendor.name }}
    </h1>

    <v-card v-if="hasEvent" class="mb-5">
      <v-container>
        <p>Hei, alle sammen</p>

        <p>
          I dag har vi med oss ekstra ferske egg, og helt ny geiteost. Kom
          gjerne innom for en smaksprøve på vår nye løvetann-smoothie.
        </p>
      </v-container>
    </v-card>

    <v-card v-if="isDemoMode" class="mt-5 mb-5">
      <v-banner icon="mdi-information-variant" color="indigo lighten-5">
        Nå er du inne på en butikk og kan se hvilke produkter som selges og
        fullføre en bestilling.
        <br />
        Merk at dette er en demo-butikk og bestillinger ikke vil bli behandlet.
        <br />
        Eneste betalingsmåte i denne demo-butikken er kontant betaling men
        systemet støtter også betaling med Vipps samt betaling med kort.
      </v-banner>
    </v-card>

    <v-card v-if="vendor.description_rendered" class="mt-5 mb-5">
      <v-banner icon="mdi-information-variant" color="green lighten-5">
        <!-- eslint-disable vue/no-v-html -->
        <div v-html="vendor.description_rendered"></div>
        <!--eslint-enable-->
      </v-banner>
    </v-card>

    <v-alert v-if="!hasProducts && !isLoading" type="error">
      Denne butikken har dessverre ingen produkter satt opp foreløpig.
    </v-alert>

    <div v-if="hasProducts">
      <v-card class="orange lighten-5" elevation="3">
        <v-card-title class="white--text orange">Produkter</v-card-title>
        <v-list two-line subheader class="orange lighten-5">
          <VendorProduct
            v-for="product in products"
            :key="product.id"
            :product="product"
            :vendor="vendor"
            @change-quantity="changeQuantity"
          />
        </v-list>

        <v-divider />

        <v-list class="orange lighten-5">
          <v-list-item> Total: kr {{ total }},- </v-list-item>
        </v-list>
      </v-card>

      <v-row class="mt-5">
        <v-col cols="12" md="6" order-md="1">
          <OrderSummary
            :order="order"
            :vendor="vendor"
            :vat-classes="vat_classes"
          />
        </v-col>

        <v-col cols="12" md="6" order-md="0">
          <Checkout
            :vendor="vendor"
            :order="order"
            :organization="organization"
          />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import VendorProduct from "@/components/VendorProduct";
import Checkout from "@/components/Checkout";
import OrderSummary from "@/components/OrderSummary";
import backend from "@/backend";

export default {
  name: "Vendor",

  components: {
    VendorProduct,
    Checkout,
    OrderSummary,
  },

  props: {
    vendorId: {
      type: String,
      required: true,
    },
  },

  data: function () {
    return {
      isLoading: null,
      vat_classes: [],
      vendor: {
        enabled_payment_methods: [],
      },
      organization: {},
      products: [],
      order: {
        orderlines: [],
        delivery_method: null,
      },
    };
  },

  computed: {
    hasProducts() {
      return this.products.length > 0;
    },

    total() {
      return this.order.orderlines.reduce((total, orderline) => {
        return total + orderline.product.price * orderline.quantity;
      }, 0);
    },

    hasEvent: function () {
      if (this.$route.params.eventId) {
        return true;
      }

      return false;
    },
    isDemoMode: function () {
      return process.env.VUE_APP_DEMO_MODE == 1;
    },
  },

  async created() {
    this.isLoading = true;
    this.vendor = await backend.get(`vendors/${this.vendorId}/`);
    this.organization = await backend.get(
      `organizations/${this.vendor.organization}/`
    );
    this.vat_classes = await backend.get("vat/");

    const product_data = await backend.get("products/", {
      vendor: this.vendor.id,
    });

    this.products = product_data.map((x) => {
      x["product_id"] = x.id;
      return x;
    });

    this.isLoading = false;
  },

  methods: {
    changeQuantity(e) {
      // Do we have the product in orderlines ?
      const orderline = this.order.orderlines.find(
        (el) => el.product.id == e.product.id
      );

      if (orderline) {
        orderline.quantity = e.quantity;

        if (orderline.quantity == 0) {
          // Orderline has 0 quantity, we remove the orderline
          this.order.orderlines = this.order.orderlines.filter((ol) => {
            return ol.product != e.product;
          });
        }
      } else {
        // Product does not exist in order,
        // we create an orderline
        this.order.orderlines.push({
          product: e.product,
          quantity: e.quantity,
        });
      }
    },
  },
};
</script>
